import { render, staticRenderFns } from "./subTopic.vue?vue&type=template&id=7ce31052&scoped=true&"
import script from "./subTopic.vue?vue&type=script&lang=js&"
export * from "./subTopic.vue?vue&type=script&lang=js&"
import style0 from "./subTopic.vue?vue&type=style&index=0&id=7ce31052&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce31052",
  null
  
)

export default component.exports